import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { ToastActionButton, type ToastPillAction } from "./toast-pill";
import { WorkToastTextPreview } from "./work-toast-text-preview";

export function WorkToastResultBody({
  text,
  bounded,
  compact = false,
  reply,
  action,
  alwaysShowAction = false,
}: {
  text: string;
  bounded: boolean;
  compact?: boolean;
  reply?: ReactNode;
  action?: ToastPillAction;
  alwaysShowAction?: boolean;
}) {
  // A bounded result scrolls inside the toast and still offers the action to open the full chat.
  const showAction = Boolean(action) && (alwaysShowAction || bounded || !reply);
  return (
    <>
      {text && (
        <div
          className={cn(
            "min-w-0 text-appkit-caption text-primary",
            bounded ? "max-h-60 overflow-y-auto overscroll-contain" : "overflow-hidden",
          )}
          data-testid="work-toast-result-text"
        >
          <WorkToastTextPreview text={text} compact={compact} />
        </div>
      )}
      {showAction && action && (
        <div className="flex justify-end">
          <ToastActionButton action={action} />
        </div>
      )}
      {reply}
    </>
  );
}
